module.exports = __webpack_public_path__ + "static/media/banner-4.9b02d5ec.png";